import React from 'react';
import { render } from 'react-dom';
import ReactDOM from "react-dom/client";


import { App } from './App';
//const root = ReactDOM.createRoot(document.getElementById("root"));
render(
  <App />,
  document.getElementById("app")
);

// root.render(
//   <React.StrictMode>
//     <App></App>
//   </React.StrictMode>
// );




// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();

